import type { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { designTokens } from '../../../design-system';

export type WorkflowRequestInformationSectionProps = {
  headingID: string;
  description: ReactNode;
  children: ReactNode;
};

/** 문서 헤더와 중복되지 않는 설명을 먼저 보여준 뒤 입력 항목을 읽는 요청 정보 영역입니다. */
export function WorkflowRequestInformationSection({
  headingID,
  description,
  children,
}: WorkflowRequestInformationSectionProps) {
  return <Box component="section" aria-label="요청 정보" sx={{ minWidth: 0 }}>
    <Stack
      component="header"
      spacing={0.5}
      data-testid="workflow-request-information-header"
      sx={{ minWidth: 0, mb: { xs: 2, sm: 2.5 } }}
    >
      <Typography
        id={headingID}
        component="h2"
        sx={{
          color: designTokens.color.primaryText,
          ...designTokens.typography.sectionTitle,
        }}
      >요청 정보</Typography>
      <Typography
        component="p"
        sx={{
          color: designTokens.color.secondaryText,
          ...designTokens.typography.body,
        }}
      >{description}</Typography>
    </Stack>
    {children}
  </Box>;
}
